export enum CalledConfigStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}



// WEBPACK FOOTER //
// ./src/app/pages/call-attendant/enums/called-config-status.enum.ts